<goab-link
  [attr.data-testid]="dataTestId()"
  color="interactive"
  [size]="resolvedLinkSize()"
  leadingIcon="chevron-back"
  [mt]="mt()"
  [mb]="mb()"
  [attr.aria-label]="resolvedAriaLabel()"
>
  @if (mode() === 'router') {
  <a
    [routerLink]="routerLink()!"
    [queryParams]="queryParams()"
    [fragment]="fragment()"
    [attr.aria-label]="resolvedAriaLabel()"
  >
    {{ label() }}
  </a>
  } @else if (mode() === 'href') {
  <a [href]="href()!" [attr.aria-label]="resolvedAriaLabel()">
    {{ label() }}
  </a>
  } @else {
  <button
    type="button"
    [attr.aria-label]="resolvedAriaLabel()"
    (click)="handleButtonClick()"
  >
    {{ label() }}
  </button>
  }
</goab-link>
